import * as React from 'react';
import { Edit, SimpleForm, TextInput, useTranslate, useRecordContext, required } from 'react-admin';

import FileUpload from '../../common/inputs/FileUpload';
import { EditToolbar } from '../../common/EditToolbar';
import PermissionGuard from '../../common/PermissionGuard';
import useIsPermission from '../../hooks/useIsPermission';
import { validateNotEmpty } from '../../common/VideoPlayer/util';

const PodcastTopicEdit = () => {
    const { isUpdatable } = useIsPermission('PODCAST');
    return (
        <PermissionGuard permission={isUpdatable}>
            <Edit mutationMode={'pessimistic'} title={<Title />} redirect={'/podcast-topics'}>
                <SimpleForm toolbar={<EditToolbar />}>
                    <FileUpload type="VIDEO_THUMBNAIL" source={'thumbnail'} accept={'image/*'} />
                    <TextInput
                        source="name"
                        fullWidth
                        name={'name'}
                        validate={[required(), validateNotEmpty]}
                    />
                    <TextInput
                        source="displayOrder"
                        type="number"
                        fullWidth
                        parse={value => (value === '' ? null : parseInt(value, 10))}
                    />
                </SimpleForm>
            </Edit>
        </PermissionGuard>
    );
};

const Title = () => {
    const record = useRecordContext();
    const translate = useTranslate();
    return record ? (
        <span>
            {translate('resources.download_categories.name', { smart_count: 1 })} &quot;
            {record.name}&quot;
        </span>
    ) : null;
};

export default PodcastTopicEdit;
